import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "packageType"]

  static outlets = ["admin--quotes--marketing-package-included-item"]

  // A package includes items of its own country and type only, so the form offers those.
  showItems() {
    const country = this.countryTarget.value
    const packageType = this.packageTypeTarget.value

    this.adminQuotesMarketingPackageIncludedItemOutlets.forEach(item => {
      item.showFor(country, packageType)
    })
  }
}
